import { Button, Checkbox, Input, Popconfirm, Select, message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import API_HOST from "../config.js";
import { testProfile } from "./cancelFunction.js";
import SelectAccounts from "./selectAccounts.js";
import { set } from "mongoose";
import SelectRemoteServer from "./selectRemoteServer.js";

function CreateAdAccountSingle(props) {
  const [loading, setLoading] = useState(false);
  const [useAPI, setUseAPI] = useState(true);
  const [profileModel, setProfileModel] = useState(testProfile);
  const [quantity, setQuantity] = useState('50');
  const [sheetName, setSheetName] = useState('USA');
  const [mccId, setMccId] = useState('');
  const [country, setCountry] = useState('CH'); // CH | US
  const [mccList, setMccList] = useState([]);
  const [createFull, setCreateFull] = useState(false);
  const [runRemote, setRunRemote] = useState(false);
  const [server, setServer] = useState('');
  
  const [messageApi, contextHolder] = message.useMessage();

  const create = async (profile) => {
    messageApi.info(`Profile: ${profile.name} >>> Tạo TK Đơn (Local)...`);
    let body = {
      profile: profile,
      mccID: mccId,
      mccList: mccList,
      quantity: +quantity,
      country,
      useAPI,
      createFull,
      sheet: {
        sheetName: sheetName,
      },
      runRemote,
      userName: `${localStorage.getItem('ga-userName')+server}`
    };
    axios
      .post(`${API_HOST}/api/account/create-ad-acc-single`, body)
      .then((res) => messageApi.success("Đang chạy..."))
      .catch((e) => {
        console.log("🚀 ~ Tạo TK Đơn (Local) ~ e:", e);
        messageApi.error(e.response.data);
      });
  };
  useEffect(() => {
    let sheetName = localStorage.getItem('sheetName')
    if(sheetName) {
      setSheetName(sheetName)
    }
  }, [])

  const onOpenChange = (open) => {
    if (open) {
      setLoading(true);
      axios
        .get(`${API_HOST}/api/profiles/${props.profile.id}`)
        .then((res) => {
          setLoading(false);
          if (res.data) {
            setProfileModel(res.data[0]);
          }
        })
        .catch((e) => {
          setLoading(false);
          messageApi.error("Không thể lấy thông tin Profile");
        });
    }
  };

  return (
    <>
      {contextHolder}
      <Popconfirm
        style={{ minWidth: 500 }}
        onOpenChange={onOpenChange}
        placement="left"
        okText="OK"
        cancelText="Hủy"
        title="Xác nhận: Tạo TK Đơn (Local MCC)"
        description={
          <>
            {profileModel?.errorMsg?.length > 0 && (
              <label style={{ color: "red", border: "1px solid red" }}>
                <strong>{profileModel?.errorMsg}</strong>
              </label>
            )}
            <br />
            <label>Nhập MCC ID (Nếu có nhiều TK MCC):</label><br />
              <Input style={{width: 300}}
                  placeholder="MCC ID"
                  onChange={(e) => setMccId(e.target.value ) }
              />
              <br />
              <SelectAccounts selectAccounts={profileModel?.selectAccounts}
                onSelected={(selected) => setMccList(selected)}
              />
              <br />
              <br />
              <Checkbox checked={runRemote} onChange={e => {
                setRunRemote(e.target.checked)
              }}>
                <i style={{color:'red'}}>Chạy trên Server</i>
              </Checkbox>
              <br />
              {runRemote && <SelectRemoteServer showAction={false} onSelected={(server) => {setServer(server)}} />}
              <label>Chọn Nước: </label>
              <Select
                  style={{width: '150px'}}
                  value={country}
                  placeholder="Chọn Nước ... "
                  onChange={(v) => {
                    setCountry(v);
                    setSheetName('CH'==v ? 'CHF': 'USA');
                  }}
                  options={[
                    {
                      label: 'CHF',
                      value: 'CH',
                    },
                    {
                      label: 'USA',
                      value: 'US',
                    },
                  ]}
                />
              <br />
              <br />
              
              <Checkbox checked={useAPI} onChange={e => setUseAPI(e.target.checked)}>
                Sử Dụng API
              </Checkbox>
              <br />
              <Checkbox checked={createFull} onChange={e => setCreateFull(e.target.checked)}>
                Tạo TK Full
              </Checkbox>
              <br />
            <label>Số Lượng: </label>
              <Input
                value={quantity}
                style={{ width: 100 }}
                placeholder="Số Lượng ..."
                onChange={(e) => setQuantity(e.target.value)}
              />
              <br />
            <label>SheetName: </label>
              <Input
                value={sheetName}
                style={{ width: 200 }}
                placeholder="SheetName ..."
                onChange={(e) => {
                  setSheetName(e.target.value);
                  localStorage.setItem('sheetName', e.target.value);
                }}
              />
          </>
        }
        onConfirm={() => create(props.profile)}
      >
        <Button type="primary" loading={loading}>
          <b>Tạo TK Đơn (Local MCC)</b>
        </Button>
      </Popconfirm>
    </>
  );
}
export default CreateAdAccountSingle;
